import { getApiUrl } from './env';

const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_REDIRECT_KEY = 'auth_redirect';
const DEFAULT_POST_LOGIN_PATH = '/dashboard';
const PUBLIC_ENTRY_PATHS = new Set(['/login']);

/** Dev fallback when Nest envía ?token= en redirect OAuth (AUTH_TOKEN_QUERY_FALLBACK). Producción usa cookie httpOnly exclusivamente vía proxy.ts + withCredentials. */
export const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token: string): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const resolvePostLoginRedirect = (path?: string | null): string => {
  if (!path || PUBLIC_ENTRY_PATHS.has(path)) {
    return DEFAULT_POST_LOGIN_PATH;
  }
  return path;
};

export const setAuthRedirect = (path: string): void => {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(AUTH_REDIRECT_KEY, resolvePostLoginRedirect(path));
};

export const consumeAuthRedirect = (): string | null => {
  if (typeof window === 'undefined') return null;
  const redirect = sessionStorage.getItem(AUTH_REDIRECT_KEY);
  if (redirect) {
    sessionStorage.removeItem(AUTH_REDIRECT_KEY);
  }
  return redirect ? resolvePostLoginRedirect(redirect) : null;
};

export const getLoginUrl = (): string => `${getApiUrl()}/auth/google`;

export const getDiscordLoginUrl = (): string => `${getApiUrl()}/auth/discord`;

export const AUTH_COOKIE_NAME = 'auth_token';
